import React from "react";
import { GroupAvatar } from "../../../../../components";

const GroupAvatarList = () => {

  const avatars = [
   {name:"Ershad Mohammad", src:"https://randomuser.me/api/portraits/men/1.jpg"},
   {name:"Vamshidhar Reddy", src:"https://randomuser.me/api/portraits/men/2.jpg"},
   {name:"Omkar Sahu", src:"https://randomuser.me/api/portraits/men/3.jpg"},
   {name:"John Doe", src:""},
   {name:"Jane Smith", src:"https://randomuser.me/api/portraits/women/1.jpg"},
   {name:"Alice Johnson", src:""},
  ];
  const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];

  return (
    <div className="my-5 flex flex-col gap-15">

      {sizes.map((size) => (
        <GroupAvatar
          key={size}
          values={avatars.map((avatar) => avatar)}
          size={size}          
        />
      ))}
    </div>
  );
};

export default GroupAvatarList;
